import { header } from './modules/header';
import { phoneMask } from './modules/phone-mask';
import { contactForm } from './modules/contact-form';
import { reveal } from './modules/reveal';

window.addEventListener('load', () => {
  reveal();
  header();
  phoneMask();
  contactForm();
});
